import { Link } from 'react-router-dom';
import { heroData } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Professional%20sports%20stadium%20at%20night%20with%20dramatic%20floodlights%20illuminating%20the%20pitch%2C%20packed%20crowd%20atmosphere%2C%20green%20grass%20field%2C%20modern%20architecture%2C%20epic%20scale%2C%20cinematic%20sports%20photography%20with%20warm%20golden%20accents%20and%20deep%20shadows&width=1800&height=900&seq=hero-bg-2026&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/65"></div>

      <div className="relative z-10 w-full container-custom text-center py-16 md:py-20">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 mb-6 md:mb-8">
          <i className="ri-fire-line text-accent-400 text-sm"></i>
          <span className="text-background-50/90 text-xs md:text-sm font-medium">{heroData.subtitle}</span>
        </div>

        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight mb-4 md:mb-6 max-w-4xl mx-auto">
          {heroData.title}
        </h1>

        <p className="text-background-50/70 text-sm md:text-base max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed">
          {heroData.description}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm md:text-base hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/25"
          >
            {heroData.primaryButton}
          </Link>
          <Link
            to="/category/football"
            className="w-full sm:w-auto px-8 py-3 rounded-lg border border-white/30 text-background-50 font-medium text-sm md:text-base hover:bg-white/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            {heroData.secondaryButton}
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mt-12 md:mt-16 max-w-3xl mx-auto">
          {heroData.stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-1">{stat.value}</div>
              <div className="text-background-50/50 text-xs md:text-sm">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}